module.exports = __webpack_public_path__ + "ui-static/img/empty_media_dark.d5351720.png";